"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { ImageType } from "..";
import { useState } from "react";
import { Swiper as SwiperCore } from "swiper";
import CustomImage from "@/components/CustomImage";
import CarouselButtons from "./CarouselButtons";

type CarouselProps = {
  images: ImageType[];
};

const Carousel = ({ images }: CarouselProps) => {
  const [isNavigationVisible, setIsNavigationVisible] = useState(true);
  const [disablePrev, setDisablePrev] = useState(true);
  const [disableNext, setDisableNext] = useState(false);

  const handleSlideChange = (swiper: SwiperCore) => {
    setDisablePrev(swiper.isBeginning);
    setDisableNext(swiper.isEnd);
  };
  const checkSlidesCount = (swiper: SwiperCore) => {
    const slidesPerView = swiper.params.slidesPerView;
    const enoughSlides = swiper.slides.length > Number(slidesPerView);
    setIsNavigationVisible(enoughSlides);
  };
  return (
    <Swiper
      onInit={(swiper) => checkSlidesCount(swiper)}
      onResize={(swiper) => checkSlidesCount(swiper)}
      onSlideChange={(swiper: SwiperCore) => handleSlideChange(swiper)}
    >
      {images.map((image) => (
        <SwiperSlide key={image.id}>
          <CustomImage
            alt={image.alt}
            src={image.src.desktop}
            srcTablet={image.src.tablet}
            srcMobile={image.src.mobile}
            className="image--bg"
          />
        </SwiperSlide>
      ))}
      {isNavigationVisible ? (
        <CarouselButtons disableNext={disableNext} disablePrev={disablePrev} />
      ) : null}
    </Swiper>
  );
};

export default Carousel;
